// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideRadar as RawLucideRadar } from "lucide-react";
export const LucideRadar = /* @__PURE__ */ createIcon(RawLucideRadar, "LucideRadar", 2);
